import { useEffect, useRef, useState } from 'react';
import { CASHIER_STAFF_MODAL_IDS } from '../../../utils/Constants';
import { staffList } from '../services/auth.services';

const openStaffListModal = () => {
  const elem = document.getElementById(CASHIER_STAFF_MODAL_IDS.STAFF_LIST_TRIGGER);
  elem?.click();
};

export const useCashierStaffList = (shouldOpenOnMount) => {
  const [list, setList] = useState([]);
  const [isStaffListLoading, setIsStaffListLoading] = useState(false);
  const [staffListError, setStaffListError] = useState(false);
  const staffListLoading = useRef(false);

  const loadStaffList = (shouldOpenModal = false) => {
    if (shouldOpenModal) {
      openStaffListModal();
    }

    if (staffListLoading.current) return;

    staffListLoading.current = true;
    setStaffListError(false);
    setIsStaffListLoading(true);
    staffList()
      .then((data) => {
        if (data && data.data) {
          setList(data.data || []);
        } else {
          setList([]);
        }
      })
      .catch((error) => {
        console.error("Error fetching staff list:", error);
        setList([]);
        setStaffListError(true);
      })
      .finally(() => {
        staffListLoading.current = false;
        setIsStaffListLoading(false);
      });
  };

  useEffect(() => {
    if (shouldOpenOnMount) {
      loadStaffList(true);
    }
  }, [shouldOpenOnMount]);

  return { list, isStaffListLoading, staffListError, loadStaffList };
};
